<template>
  <div class='noticeList font18'>
    <switch-role @changes='getList' v-if="$route.name!=='noticeIndex'"></switch-role>
    <van-list  :offset='70'>
      <div class="list" v-for='(item,i) in list' :key='i' @click="gotoUrl('noticeList',{msgType:item.msgType})">
          <div>
            <van-badge :content="item.unReadNum"  max="99" v-if="item.unReadNum>0">
              <template v-if='item.msgType=="SOS"||item.msgType=="FENCE"||item.msgType=="TOUCH"'>
                <img :src="require('@/assets/img/'+item.msgType+'.png')"> 
              </template>
              <img :src="require('@/assets/img/SUGGEST.png')" v-else> 
             </van-badge>
            <template v-else>
               <template v-if='item.msgType=="SOS"||item.msgType=="FENCE"||item.msgType=="TOUCH"'>
                <img :src="require('@/assets/img/'+item.msgType+'.png')"> 
              </template>
              <img :src="require('@/assets/img/SUGGEST.png')" v-else> 
            </template>
          </div>
          <div class='con'>
             <p><span class='title'>{{item.msgTypeName}}</span><span class='time font14' v-if="item.lastMessage">{{item.lastMessage.messageTime}}</span></p>
             <p class="tit gray font15" v-if="item.lastMessage">{{item.lastMessage.msgContent}}</p>
             <p class="tit gray font15" v-else>暂无消息</p>
          </div>
      </div>
    </van-list>
    
  </div>
</template>
<script>
  import {pageListMessageByType} from "@/api/api.notice";
  import switchRole from "../report/components/switchRole.vue";

  export default {
    data() {
      return {
        list:[],
        text:'暂无消息',
        userType:this.$store.state.loginUser.currentUserType,//3老师，5家长
        identityId:'',
        pageNo:1,
        pageSize:10,
        isLoading:false,
        isFinish:true,
        finishText:'',
        total:0,
        nodataFlag:true
      }
    },
    components:{switchRole},

    created(){
     
      this.getList();
    },
    methods: {

      getList(){
        if(this.userType==3){//老师
          this.identityId=this.$store.state.users.teacher.teacherId
        }else if(this.userType==5){//家长
          this.identityId=this.$store.state.users.parent.parentId
        }
        pageListMessageByType({
          identityId:this.identityId,
        }).then(data=>{
          this.nodataFlag=false
          data.result.forEach((item)=>{
            if(item.lastMessage!=null){
              this.nodataFlag=true
            } 
          })
          this.list=data.result
        })
      },
    },
  }
</script>
<style lang="scss" >
.noticeList{
  color:rgba(0,0,0,.9);
  .list{
    padding:.15rem .1rem;
    display: flex;
    background: #fff;
    position: relative;
    border-bottom: 1px solid #eee;
    img{
      width: .44rem;
      // margin-top: -.05rem;
      // margin-right: .05rem;
    }
    .con{
      margin-left: 0.12rem;
      width: 80%;
      .title{
          font-weight: 550;
        }
      .time{
        position: absolute;
        right: .1rem;
        color:rgba(0,0,0,.4);
      }
      .tit{
        padding-top: .03rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

</style>